import cn from "classnames";
import { MagnifyingGlassIcon } from "@heroicons/react/24/solid";

/* Prop Types */
export interface SearchProps extends React.InputHTMLAttributes<HTMLInputElement> {
  containerClassName?: string;
  iconClassName?: string;
}

/*
 * Search component
 * This component is used to display a search input normally used to query studies and projects
 */
export const Search = ({ className, iconClassName, ...props }: SearchProps) => {
  /* Render */
  return (
    <label className={cn("input flex h-auto items-center gap-2 border-2 py-2 px-3 bg-base-200 focus:outline-base-100 border-base-300", className)}>
      <input type="text" placeholder="Search" className="text-sm" {...props} />
      <MagnifyingGlassIcon className={cn("size-4 font-semibold", iconClassName)} />
    </label>
  );
};
